export default function MidCTA() {
  const scrollToContact = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative py-24 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/860919c13f48b7d7991254f207fda588.jpg"
          alt="Professional home inspection in progress"
          className="w-full h-full object-cover object-center"
        />
        {/* Strong solid overlay — text must be fully legible */}
        <div className="absolute inset-0 bg-[#050505]/88"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/60 via-[#050505]/20 to-transparent"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-14">
        <div className="max-w-xl">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-8 h-px bg-[#C9A961]"></div>
            <span className="text-[#C9A961] text-xs font-semibold uppercase tracking-[0.2em]">Get Started</span>
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight"
            style={{ fontFamily: "'Playfair Display', serif", textShadow: '0 2px 16px rgba(0,0,0,0.5)' }}
          >
            Ready to Schedule
            <br />
            Your Inspection?
          </h2>
          <p className="text-white/85 text-lg mb-10 font-medium">
            Fast booking. Certified professionals. Clear results.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={scrollToContact}
              className="bg-[#C9A961] text-white font-semibold text-base px-9 py-4 rounded-md hover:bg-[#b8944f] transition-all duration-200 hover:-translate-y-0.5 cursor-pointer whitespace-nowrap"
            >
              Schedule Inspection
            </button>
            <a
              href="tel:+12814217355"
              className="flex items-center justify-center gap-2.5 bg-white/10 backdrop-blur-sm border border-white/45 text-white font-semibold text-base px-9 py-4 rounded-md hover:bg-white/18 hover:border-white/75 transition-all duration-200 whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-[#C9A961]"></i>
              </div>
              Call (281) 421-7355
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
